(function () {
    'use strict';

    angular
        .module('sodCommon')
        .service('PageDirtyChecker', PageDirtyChecker);

    function PageDirtyChecker(FormBuilderService, ModalService, $q, $timeout) { // eslint-disable-line no-unused-vars
        this.hasDirtyForm = () => {
            return FormBuilderService.hasDirtyForm();
        };

        this.showConfirmation = function() {
            // how to pass dynamic data to this confirmation
            const modalQ = $q.defer();

            $timeout(function() {
                ModalService.showModal({
                    templateUrl: 'common/app/components/page-dirty-confirmation',
                    controller: 'PageDirtyConfirmationCtrl',
                    controllerAs: 'vm',
                    appendElement: angular.element('.modal-wrapper'),
                    inputs: {}
                }).then(function (modal) {
                    modal.element.show();
                    modal.close.then(function(result) {
                        (result) ? modalQ.resolve() : modalQ.reject();
                    });
                });
            });

            return modalQ.promise;
        };
    }
})();
